var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch",class:{active: _vm.state},on:{"click":function($event){return _vm.update()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }